<template>
  <div class="stats-table">
    <div
      class="st-row-header"
      :style="`grid-template-columns: ${columnTemplate};`"
    >
      <div class="st-label">&nbsp;</div>
      <div
        v-for="header in headers"
        :key="header"
      >
        <Icon
          v-if="header.type == 'icon'"
          v-tippy="header.label"
          :type="header.iconValue"
        />
        <div v-else>{{ header.value }}</div>
      </div>
    </div>
    <div class="st-rows">
      <div
        v-for="row in rowsData"
        :key="row"
        class="st-row"
        :style="`grid-template-columns: ${columnTemplate};`"
      >
        <div
          v-for="(cell, i) in row"
          :key="i"
          :class="[cell.isLabel ? 'st-label' : 'st-cell']"
        >
          <div v-if="cell.field">
            <slot
              :name="cell.field"
              :data="cell"
            ></slot>
          </div>
          <div v-else>{{ cell.isLabel ? cell.value : cell }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import Icon from '@/components/icon/Icon.vue'

defineProps({
  columnTemplate: {
    // eg 1fr, 1fr, 1fr, 1fr
    type: String,
    default: ''
  },
  headers: {
    type: Array,
    default: () => []
  },
  rowsData: {
    type: Array,
    default: () => []
  }
})
</script>

<style>
.st-row-header,
.st-row {
  display: grid;
  grid-template-rows: auto;
}
.st-row-header {
  text-align: center;
}
.st-row-header > div {
  padding: var(--s-2);
}

.st-row > div {
  padding: var(--s-2);
  border-style: solid;
}

.st-row > .st-cell {
  border-top: 1px;
  border-color: var(--border-primary);
  border-style: solid;
  text-align: center;
}

.st-rows > .st-row > .st-cell:nth-child(2) {
  border-left: 1px solid var(--border-primary);
}
.st-rows > .st-row > .st-cell:last-of-type {
  border-right: 1px solid var(--border-primary);
}

.st-rows > .st-row:nth-child(1) > .st-cell:nth-child(2) {
  border-radius: var(--rounded-md) 0 0 0;
}
.st-rows > .st-row:nth-child(1) > .st-cell:last-of-type {
  border-radius: 0 var(--rounded-md) 0 0;
}
.st-rows > .st-row:last-of-type > .st-cell:nth-child(2) {
  border-radius: 0 0 0 var(--rounded-md);
}
.st-rows > .st-row:last-of-type > .st-cell:last-of-type {
  border-radius: 0 0 var(--rounded-md) 0;
}

.st-row:last-of-type > .st-cell {
  border-bottom: 1px;
  border-color: var(--border-primary);
  border-style: solid;
}
</style>

<!-- Example Usage -->
<!-- <StatsTable
  columnTemplate="1fr 1fr 1fr 1fr"
  :headers="[
    { type: 'icon', iconValue: 'user-clock', label: 'Productive Hours' },
    { type: 'icon', iconValue: 'phone', label: 'Call Target' },
    { type: 'icon', iconValue: 'calendar', label: 'Appointment Target' }
  ]"
  :rowsData="[
    [
      { isLabel: true, value: 'Today' },
      5,
      { slotRef: 'callTarget', callsMade: 17, callTarget: 25 },
      { slotRef: 'appointmentTarget', appointmentsBooked: 12, appointmentTarget: 20 }
    ],
    [
      { isLabel: true, value: 'This Week' },
      35,
      { slotRef: 'callTarget', callsMade: 132, callTarget: 250 },
      { slotRef: 'appointmentTarget', appointmentsBooked: 110, appointmentTarget: 150 }
    ],
    [
      { isLabel: true, value: 'This Month' },
      170,
      { slotRef: 'callTarget', callsMade: 479, callTarget: 650 },
      { slotRef: 'appointmentTarget', appointmentsBooked: 364, appointmentTarget: 400 }
    ]
  ]"
/> -->
